/**
 * Debounce delay (ms) for search requests sent through the BFF proxy to the
 * Asset Management API.
 * This delay is intentionally longer because the API scans a large dataset and
 * should be called less frequently.
 */
export const API_SEARCH_DEBOUNCE_DELAY_MS = 600;
